import React from "react";
import Link from "next/link";
import LogoWeiß from "@/assets/svgs/LogoWeiß";
import XLogo from "@/assets/svgs/XLogo";
import FacebookLogo from "@/assets/svgs/FacebookLogo";
import InstagramLogo from "@/assets/svgs/InstagramLogo";
import AppStore from "@/assets/svgs/AppStore";
import PlayStore from "@/assets/svgs/PlayStore";
import "./Footer.css";

import ButtonAnimated from "../ButtonAnimated/ButtonAnimated";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-column-wrapper">
        <div className="footer-column first">
          <div className="footer-logo-socials">
            <LogoWeiß
              width="160"
              height="48"
              alt="Auto Einfach Los"
              color="#fff"
            />
            <div className="footer-socials-wrapper">
              <a
                href="https://www.facebook.com/Autoeinfachlos"
                target="_blank"
                rel="noopener norefferer"
                className="footer-social"
              >
                <FacebookLogo
                  alt="facebook"
                  className="footer-socials-icon"
                  width={24}
                  height={24}
                />
              </a>
              <div className="footer-social">
                <XLogo
                  alt="x"
                  className="footer-socials-icon"
                  width={24}
                  height={24}
                />
              </div>
              <div className="footer-social">
                <InstagramLogo
                  alt="instagram"
                  className="footer-socials-icon"
                  width={24}
                  height={24}
                />
              </div>
            </div>
          </div>

          <div className="footer-appStores">
            <AppStore
              alt="Download im AppStore"
              className="footer-appStore-icon"
              width={152}
              height={51}
            />

            <PlayStore
              alt="Download im PlayStore"
              className="footer-appStore-icon"
              width={152}
              height={51}
            />
          </div>
        </div>
        <div className="footer-column second">
          <h4>Über Autoeinfachlos</h4>

          <ul className="footer-list-wrapper">
            <li className="footer-list-item">
              <Link href="/ueber-uns">
                <span>Über uns </span>
              </Link>
            </li>
            <li className="footer-list-item">
              <Link href="/so-funktionierts">
                <span>So funktionierts</span>
              </Link>
            </li>
            <li className="footer-list-item">
              <Link href="/">
                <span>Erfahrungen</span>
              </Link>
            </li>
            <li className="footer-list-item">
              <Link href="/">
                <span>Ratgeber</span>
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-column third">
          <h4>Service</h4>

          <ul className="footer-list-wrapper">
            <li className="footer-list-item">
              <Link href="/auto-verkaufen">
                <span>Auto Verkaufen</span>
              </Link>
            </li>
            <li className="footer-list-item">
              <Link href="/auto-bewerten">
                <span>Bewertungstool</span>
              </Link>
            </li>
            <li className="footer-list-item">
              <Link href="/fahrgestellnummer-pruefen">
                <span>FIN Prüfen tool</span>
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-column fourth">
          <h4>Hilfe & Information</h4>

          <ul className="footer-list-wrapper">
            <li className="footer-list-item">
              <Link href="/faq">
                <span>Häufige Fragen</span>
              </Link>
            </li>
            <li className="footer-list-item">
              <Link href="/kontaktiere-uns">
                <span>Kontaktiere uns</span>
              </Link>
            </li>
            <li className="footer-list-item">
              <Link href="/presse">
                <span>Presse</span>
              </Link>
            </li>
            <li className="footer-list-item">
              <Link href="tel:+43720881186">
                <span>Telefon: +43 720 881186</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-end-wrapper">
        <ButtonAnimated
          text="Autoeinfachlos für Händler"
          fill="#fff"
          width="336px"
          height="58px"
          hideMaxWidth
          borderColor="#61615e"
          hoverBorderColor="#fff"
          backgroundColor="transparent"
          hoverBackgroundColor="#343431"
          color="#fff"
          fontSize="18px"
          chevronHeight="22px"
          className="desktop"
          link="https://pro.autoeinfachlos.at"
        />

        <ButtonAnimated
          text="Autoeinfachlos für Händler"
          fill="#fff"
          width="300px"
          height="48px"
          borderColor="#61615e"
          hoverBorderColor="#fff"
          backgroundColor="transparent"
          hoverBackgroundColor="#343431"
          color="#fff"
          fontSize="16px"
          chevronHeight="22px"
          className="mobile"
          hideMaxWidth
          link="https://pro.autoeinfachlos.at"
        />
        <ul className="footer-end-list">
          <li className="footer-end-list-item transition">
            <Link href="/impressum">Impressum</Link>
          </li>
          <li className="footer-end-list-item transition">
            <Link href="/agb">AGB</Link>
          </li>
          <li className="footer-end-list-item transition">
            <Link href="/datenschutz">Datenschutz</Link>
          </li>
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
